"use strict";

exports.__esModule = !0, exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base")),
  _react = _interopRequireWildcard(require("react")),
  _util = require("../util"),
  PropTypes = _interopRequireWildcard(require("prop-types")),
  _constants = require("../constants");
function _getRequireWildcardCache(a) {
  if ("function" != typeof WeakMap) return null;
  var b = new WeakMap(),
    c = new WeakMap();
  return (_getRequireWildcardCache = function (a) {
    return a ? c : b;
  })(a);
}
function _interopRequireWildcard(a, b) {
  if (!b && a && a.__esModule) return a;
  if (null === a || "object" != typeof a && "function" != typeof a) return {
    default: a
  };
  var c = _getRequireWildcardCache(b);
  if (c && c.has(a)) return c.get(a);
  var d = {},
    e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var f in a) if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
    var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
    g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
  }
  return d.default = a, c && c.set(a, d), d;
}
function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, _setPrototypeOf(a, b);
}
function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}
var handlePlaceHolder = function (a, b) {
    var c = a.addPlaceholder,
      d = a.searchable,
      e = a.placeholder,
      f = b.values && 0 === b.values.length,
      g = b.values && 0 < b.values.length;
    return g && c && d ? c : f ? e : g && !d ? "" : "";
  },
  Input = /*#__PURE__*/function (a) {
    function b() {
      for (var b, c = arguments.length, d = Array(c), e = 0; e < c; e++) d[e] = arguments[e];
      return b = a.call.apply(a, [this].concat(d)) || this, b.input = /*#__PURE__*/_react.default.createRef(), b.onBlur = function (a) {
        return a.stopPropagation(), b.props.state.dropdown ? b.input.current.focus() : b.input.current.blur();
      }, b.handleKeyPress = function (a) {
        var c = b.props,
          d = c.props,
          e = c.state,
          f = c.methods;
        return d.create && "Enter" === a.key && !(0, _util.valueExistInSelected)(e.search, [].concat(e.values, d.options), b.props) && e.search && null === e.cursor && f.createNew(e.search);
      }, b;
    }
    _inheritsLoose(b, a);
    var c = b.prototype;
    return c.componentDidUpdate = function componentDidUpdate(a) {
      (this.props.state.dropdown || a.state.dropdown !== this.props.state.dropdown && this.props.state.dropdown || this.props.props.autoFocus) && this.input.current.focus(), a.state.dropdown === this.props.state.dropdown || this.props.state.dropdown || this.input.current.blur();
    }, c.render = function render() {
      var a = this.props,
        b = a.props,
        c = a.state,
        d = a.methods;
      return b.inputRenderer ? b.inputRenderer({
        props: b,
        state: c,
        methods: d,
        inputRef: this.input
      }) : /*#__PURE__*/_react.default.createElement(InputComponent, {
        ref: this.input,
        tabIndex: "-1",
        onFocus: function onFocus(a) {
          return a.stopPropagation();
        },
        className: _constants.LIB_NAME + "-input",
        size: d.getInputSize(),
        value: c.search,
        readOnly: !b.searchable,
        onClick: function onClick() {
          return d.dropDown("open");
        },
        onKeyPress: this.handleKeyPress,
        onChange: d.setSearch,
        onBlur: this.onBlur,
        placeholder: handlePlaceHolder(b, c),
        disabled: b.disabled
      });
    }, b;
  }(_react.Component),
  InputComponent = /*#__PURE__*/(0, _base.default)("input", "production" === process.env.NODE_ENV ? {
    target: "e11wid6y0"
  } : {
    target: "e11wid6y0",
    label: "InputComponent"
  })("line-height:inherit;border:none;margin-left:5px;background:transparent;padding:0;width:calc(", function (a) {
    var b = a.size;
    return b + "ch";
  }, " + 5px);font-size:smaller;", function (a) {
    var b = a.readOnly;
    return b && "cursor: pointer;";
  }, " :focus{outline:none;}" + ("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
  _default = Input;
exports.default = _default;